import styled, { css } from 'styled-components';
import { focusStyles } from '@bechtel/gds';

export const FileUploadContainer = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.blue[700]};
    border-radius: ${theme.radii[200]};
    margin-bottom: ${theme.spacings[500]};
    padding: ${theme.spacings[500]};

    &:hover {
      background-color: ${theme.colors.grey[100]};
    }
  `}

  align-items: center;
  cursor: pointer;
  display: flex;
  height: 120px;
  justify-content: center;
  text-align: center;

  ${focusStyles};
`;

export const PhotoContainerStyled = styled.div`
  position: relative;
`;

export const DeletePhotoStyled = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;
